/* unplugin-vue-components disabled */import script from "./dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=1cebbac4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cebbac4"]])

export default __exports__